<template>
    <div>
        <v-snackbar :right="true" :timeout="3000" :top="true" color="error" v-model="snackbar">
            {{ notificationMessage }}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>
        <div class="login-container">
            <v-card class="login-card">
                <v-card-text>
                    <top-header-section text-item="TOKEN VERIFICATION"></top-header-section>
                    <span>A 6 digit numeric token has been sent to {{mobile}} and {{trekkingAgencyData.agency_email}}</span>
                    <v-form @submit="registerAgency" action="#" ref="registerForm">
                        <FormErrorDisplayHandler :errors="errors"></FormErrorDisplayHandler>
                        <v-text-field
                                :rules="[rules.required]"
                                class="mt-4"
                                label="Token *"
                                outlined
                                type="text"
                                v-model="form.token"
                        ></v-text-field>
                        <v-text-field
                                :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                                :rules="[rules.required]"
                                :type="passwordShow ? 'text' : 'password'"
                                @click:append="passwordShow = !passwordShow"
                                label="Password *"
                                outlined
                                prepend-inner-icon="fingerprint"
                                v-model="form.password"
                        ></v-text-field>
                        <v-text-field
                                :append-icon="confirmPasswordShow ? 'visibility_off' : 'visibility'"
                                :rules="[rules.required, passwordConfirmationRule]"
                                :type="confirmPasswordShow ? 'text' : 'password'"
                                @click:append="confirmPasswordShow = !confirmPasswordShow"
                                label="Confirm Password *"
                                outlined
                                prepend-inner-icon="fingerprint"
                                v-model="form.password_confirmation"
                        ></v-text-field>
                        <v-btn :disabled="loading" class="login-button mt-0" color="primary" large type="submit">
                            Submit
                        </v-btn>
                    </v-form>

                </v-card-text>
            </v-card>
        </div>

    </div>
</template>

<script>
    import FormErrorDisplayHandler from "../../components/FormErrorDisplayHandler";
    import TopHeaderSection from "../../components/TopHeaderSection";
    import {mapGetters, mapActions} from "vuex";

    export default {
        data: () => ({
            loading: false,
            snackbar: false,
            valid: true,
            passwordShow: false,
            confirmPasswordShow: false,
            notificationMessage: "",
            form: {
                password: '',
                password_confirmation: '',
                token: '',
            },
            errors: [],
            rules: {
                required: value => !!value || "Required.",
            },
        }),
        components: {FormErrorDisplayHandler,TopHeaderSection},
        mounted() {
            if (!this.mobile) {
                this.$router.replace("/register");
            }

        },
        computed: {
            ...mapGetters({trekkingAgencyData: 'TrekkingSingle/trekkingAgencyData', mobile: 'AuthUser/mobile'}),
            passwordConfirmationRule() {
                return () => (this.form.password === this.form.password_confirmation) || 'Password must match'
            },
            mobile_number() {
                return  this.trekkingAgencyData.get('mobile_number');
            }
        },
        methods: {
            ...mapActions("AuthUser", ["register", "resetState"]),
            registerAgency(e) {
                if(this.$refs.registerForm.validate()){
                let formData = new FormData();
                formData = this.trekkingAgencyData;
                formData.set("register_trekking_agency", "true");
                formData.set("token", this.form.token);
                formData.set("password", this.form.password);
                formData.set("password_confirmation", this.form.password_confirmation);
                e.preventDefault();
                this.register(formData).then(() => {
                    this.$store.commit('Notification/showSuccess', 'Registration successful but the account is yet to be verified')
                    this.$router.replace("/login");


                }).catch((error) => {
                    if (parseInt(error.response.status) === 422 || parseInt(error.response.status) === 400) {
                        this.errors = error.response.data.errors;
                    }

                    window.scrollTo(0, 0);
                    this.loading = false;
                })

                // console.log(formData);
                // if (this.$refs.tokenForm.validate()) {
                //     Http.post(API_URL + VERSION + '/trekking/password/reset', {
                //         token: this.form.token,
                //         password: this.form.new_password,
                //         password_confirmation: this.form.confirm_password
                //     })
                //         .then(response => {
                //             if (response.status === 200) {
                //                 this.$router.replace("/login");
                //             } else {
                //                 this.notificationMessage = response.data.message;
                //                 this.snackbar = true;
                //             }
                //         })
                //         .catch((error) => {
                //             if (parseInt(error.response.status) === 422 || parseInt(error.response.status) === 400) {
                //                 this.errors = error.response.data.errors;
                //             }
                //
                //             window.scrollTo(0, 0);
                //             this.loading = false;
                //         })
                } else {
                    this.$store.commit("Notification/showError", 'Invalid form data');
                }
            },
        }
    };
</script>
